import React,{Component} from 'react';
import GoogleAnalytics from "react-ga";
import {getAnaliticUserCode} from './api/commons'
import {withRouter} from "react-router";
GoogleAnalytics.initialize(getAnaliticUserCode(),{debug:true});

const withTracker = (WrappedComponent, options = {}) => {
  const trackPage = page => {

    GoogleAnalytics.pageview(page);
  };

  const HOC = class extends Component {
    componentDidMount() {
      const page = this.props.location.pathname;
      trackPage(page);
    }

    componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;
      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {

      return <WrappedComponent {...this.props} />;
    }
  };

  return withRouter(HOC);
};

export default withTracker;
